export class ApptResourceModel {
    appt_resource_code: string
    appt_resource_date: any
    appt_resource_time_str: string

    constructor(
        appt_resource_code: string,
        appt_resource_date: any,
        appt_resource_time_str: string
    ) {
        this.appt_resource_code = appt_resource_code
        this.appt_resource_date = appt_resource_date
        this.appt_resource_time_str = appt_resource_time_str
    }
}


export class CboDefApptResourceModel {
    def_appt_resource_id: number
    def_appt_resource_code: string
    def_appt_resource_category: string

    constructor(
        def_appt_resource_id: number,
        def_appt_resource_code: string,
        def_appt_resource_category: string,
    ) {
        this.def_appt_resource_id = def_appt_resource_id
        this.def_appt_resource_code = def_appt_resource_code
        this.def_appt_resource_category = def_appt_resource_category
    }
    
}


export class CboApptResourceModel {
    appt_resource_id: number
    appt_resource_code: string
    appt_resource_category: string

    constructor(
        appt_resource_id: number,
        appt_resource_code: string,
        appt_resource_category: string,
    ) {
        this.appt_resource_id = appt_resource_id
        this.appt_resource_code = appt_resource_code
        this.appt_resource_category = appt_resource_category
    }
}

export class tblApptResourceModel {
    appt_resource_id: number
    appt_resource_code: string
    appt_resource_category: string
    appt_resource_date: Date
    appt_resource_time_str: string
    appt_doctor_load: string
    clinic_no: number

    constructor(
        appt_resource_id: number,
        appt_resource_code: string,
        appt_resource_category: string,
        appt_resource_date: Date,
        appt_resource_time_str: string,
        appt_doctor_load: string,
        clinic_no: number
    ) {
        this.appt_resource_id = appt_resource_id
        this.appt_resource_code = appt_resource_code
        this.appt_resource_category = appt_resource_category
        this.appt_resource_date = appt_resource_date
        this.appt_resource_time_str = appt_resource_time_str
        this.appt_doctor_load = appt_doctor_load
        this.clinic_no = clinic_no
    }
}

 